import React, { Component } from 'react';
import AI from '../../assets/Product/AI.svg';
import TwoScan from '../../assets/Product/twoscan.svg';
import Prediction from '../../assets/Product/Prediction.svg';
import Scan from '../../assets/Product/scan.svg';
import Report from '../../assets/Product/report.svg';
import Dashboard from '../../assets/Product/dashboard.svg';
import Feature from './Feature/Feature';
import './Features.css';

export default function Features(props) {
    return (
        <div className="features">
            <h3 className="heading">ThreatSpy Features</h3>
            <div className="container">
                <div className="row features-list1">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={AI} cont="Next Generation AI Enabled Scanner" content="AI enabled scanner which predicts the possibility of threats on your web application and server." />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={TwoScan} cont="Light Scan And Deep Scan " content="Multiple scanning mechanisms which can be used based on the level of threat." />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={Prediction} cont="Early Prediction Of Cyber Attack " content="Stay prepared before your application data gets exposed due to cyber attacks. " />
                    </div>
                </div>
                <div className="row features-list2">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={Scan} cont="Scan Scheduler" content="Schedule scans on your web application at regular intervals to stay updated." />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={Report} cont="Real Time Assessment Report" content="Get instant scores for your web application and servers depending on the threat levels." />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <Feature src={Dashboard} cont="Interactive Dashboard" content=" Easy to use interface that enables you to visualize assessment reports effectively." />
                    </div>
                </div>
            </div>
        </div>
    )
}